import {Component, inject,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {KulturNavParams} from '../../core/definitions/kultur-nav/kultur-nav-params';

@Component({
    selector: 'app-kultur-nav-search-dialog',
    templateUrl: './kultur-nav-search-dialog.component.html',
    styleUrls: ['./kultur-nav-search-dialog.component.scss'],
    standalone: false
})
export class KulturNavSearchDialogComponent {
  // Injections
  public data: KulturNavParams = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<KulturNavSearchDialogComponent> = inject(MatDialogRef);
}
